import type { FC } from "react";

import WhitelistCategoryView from "../components/WhitelistCategoryView";
import KeepOpenAction from "./KeepOpenAction";

const LiquidatorWhitelistRoute: FC = () => {
  return (
    <WhitelistCategoryView
      category="liquidator"
      title="Liquidator"
      headerActions={items => <KeepOpenAction items={items} />}
    />
  );
};

export default LiquidatorWhitelistRoute;
